import { ProfilePhoto } from "@minervaproject/fds";
import React from "react";

import { FeatureBreakoutRoomButtons } from "./feature_breakout_room_buttons";

import { ListenButton } from "components/breakout_control_room/listen_button";
import { PinButton } from "components/breakout_control_room/pin_button";
import { VisitButton } from "components/breakout_control_room/visit_button";
import { useAppSelector } from "hooks/redux_hooks";
import { BreakoutRoomType } from "shared/types";
import { UserType } from "shared/types/user";
import { localSelectors } from "store";
import { computeInitials, profilePhotoUrl } from "utils/user";

function PinnedBreakoutRoom({
  breakoutRoom,
  allUsers,
  activeBreakoutSessionId,
  isCurrentUserVisitingAnyBreakoutRoom = false,
}: {
  breakoutRoom: BreakoutRoomType;
  allUsers: UserType[];
  activeBreakoutSessionId?: string;
  isCurrentUserVisitingAnyBreakoutRoom?: boolean;
}) {
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const isCurrentUserVisitingThisBreakoutRoom =
    breakoutRoom.visiting_user_ids.includes(currentUserId);

  return (
    <div className="p2 mb2 bg-black-tint-20" data-testid="pinned-breakout-room">
      <div className="flex justify-between body-s bold text-white">
        <div>Breakout Group {breakoutRoom.title}</div>
        <PinButton
          breakoutRoom={breakoutRoom}
          unpinButtonText="Unpin"
          buttonTextClassName="text-white body-s bold"
          noPadding
        />
      </div>
      <div className="py2">
        {breakoutRoom.assigned_user_ids.map((userId, index) => {
          const user = allUsers.find((_user) => _user.id === userId);
          return (
            user && (
              <ProfilePhoto
                key={user.id}
                className="outline-2-black-tint-20"
                size="md"
                src={profilePhotoUrl(user)}
                initials={computeInitials(user)}
                style={{ marginLeft: index > 0 && "-8px" }}
              />
            )
          );
        })}
      </div>
      {!isCurrentUserVisitingThisBreakoutRoom && (
        <div
          className="flex items-center pt2"
          style={{ borderTop: "1px solid var(--black-tint-40)" }}
        >
          {activeBreakoutSessionId ? (
            <>
              <VisitButton breakoutRoom={breakoutRoom} showButtonText />
              <div className="mr2" />
              {!isCurrentUserVisitingAnyBreakoutRoom && (
                <ListenButton breakoutRoom={breakoutRoom} showButtonText />
              )}
            </>
          ) : (
            <FeatureBreakoutRoomButtons breakoutRoom={breakoutRoom} allUsers={allUsers} />
          )}
        </div>
      )}
    </div>
  );
}

export { PinnedBreakoutRoom };
